function getUserBase(state) {
  const base = state.ui.common.onboarding;
  return base[base.active] || {};
}

export function getSeenStates(state) {
  const base = getUserBase(state);
  const result = {};
  Object.keys(base)
    .filter(k => k !== 'expires')
    .forEach(k => {
      if (base[k].seen) {
        result[k] = true;
      }
    });
  return result;
}

export function hasBeenSeen(state, id) {
  return !!getSeenStates(state)[id];
}

export function getExpiration(state) {
  return getUserBase(state).expires;
}



// WEBPACK FOOTER //
// ./src/app/api/redux-ui/common/onboarding/selectors.js